<template>
    <form @submit.prevent="handleSubmit" class="form-signin shadow p-3 mb-5 bg-white rounded">
        <h1 class="h3 mb-3 fw-normal">Please register</h1>

        <div class="input-wrapper mt-3">
          <input type="email" class="frmcontrol focus-ring" v-model="email" placeholder="Email" required/>
        </div>

        <input type="text" class="frmcontrolnoicon frmcontrol mt-3 focus-ring"  v-model="first_name" placeholder="First name" required/>
 
        <input type="text" class="frmcontrolnoicon mt-3 frmcontrol focus-ring" v-model="last_name" placeholder="Last name" required/>
      

        <div class=" mt-3">
          <!-- <div class="input-wrapper1 mt-3"> -->
          <input :type="fieldType" class="frmcontrol focus-ring" v-model="password"  placeholder="Password" required/>
          <i class="fa-solid fa-eye" id="eye" @click="obfuscateToggle"></i>          
        </div>

        <div class="mt-3">
          <input :type="fieldTypeConfirm" class="frmcontrol focus-ring" v-model="password2"  placeholder="Password confirm" required/>
          <i class="fa-solid fa-eye" id="eye" @click="obfuscateToggleConfirm"></i>        
        </div>

        <button class="btn btn-primary w-100 py-2" type="submit">Submit</button>
    </form>
</template>

<script>
import axios from 'axios'

export default {
    name: 'Register',
    data() {
        return {
            email: '',
            first_name: '',
            last_name: '',
            password: '',
            password2: '',
            passwordVisible: false,
            fieldType: 'text',
            fieldTypeConfirm: 'text'
        }
    },
    props: {
          type: { type: String, default: "text" },
    },
    methods: {
      async handleSubmit() {
            const response = await axios.post('register/', {
               email: this.email, 
               first_name: this.first_name, 
               last_name: this.last_name, 
               password: this.password, 
               password2: this.password2, 
            });
           
            console.log(response);
            this.$router.push('/otpverify');
        },
      obfuscateToggle() {
          this.fieldType = this.fieldType == "text" ? "password" : "text"
      },
      obfuscateToggleConfirm() {
          this.fieldTypeConfirm = this.fieldTypeConfirm == "text" ? "password" : "text"
      },
    },
  mounted(){
   this.fieldType = this.type;
   this.fieldTypeConfirm = this.type;
  },
  watch:{
   type(val){
      this.fieldType = val;
      this.fieldTypeConfirm = val;
   }
  }

}
</script>

<style scoped>

:root {
  --bs-focus-ring-x: 0px; 
  --bs-focus-ring-y: 0px;
  --bs-focus-ring: 0; 
  --bs-focus-ring-blur: 0px;
  --focus-ring-width: 0px;
  --focus-ring-opacity: 0;
  --focus-ring-color: none;
}
  .form-signin {
    width: auto;
    max-width: 330px;
    padding: 15px;
    margin: auto;
    margin-top: 100px;
  }
  
  .form-signin .checkbox {
    font-weight: 400;
  }
  
  .form-signin .form-floating:focus-within {
    z-index: 2;
  }
  
  /* .form-signin input[type="email"] {
    margin-bottom: -1px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  } */
  
  .form-signin input[type="password"] {
    margin-bottom: 10px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;

  }
  .input-wrapper {
        display:inline-block;
        position: relative;
        width: 100%;
    }
    .input-wrapper:after {
        font-family: 'FontAwesome';
        content: '\f0e0';
        position: absolute;
        color: grey;
        right: 6px;
        font-size: 25px;
    }

    .frmcontrol {
      width: 100%;
      height: 40px;
      margin-bottom: 20px;
      padding-inline-start: 15px;
      border: 0;
      border-bottom: thin solid blue;
    }

    .frmcontrol:focus {
      border: 0;
      box-shadow: none;
      border-bottom: thin solid blue;
    }

    .frmcontrol:focus::placeholder {
      color: transparent;
    }

    .fa-eye{
      position: relative;
      top: -50px;
      right: -270px;
      cursor: pointer;
      color: blue;
    }
    .frmcontrolnoicon {
      width: 100%;
      
      height: 40px;
      margin-bottom: 20px;
      padding-inline-start: 15px;
    }

    .input-wrapper1 {
        display:inline-block;
        position: relative;
        width: 100%;
    }
    .input-wrapper1:after {
        font-family: 'FontAwesome';
        content: '\f084';
        position: absolute;
        color: grey;
        right: 6px;
        font-size: 25px;
    }
</style>